module.exports = __webpack_public_path__ + "img/step1-01.88ae2f14.png";